<app-breadcrumb [title]="page_name" [breadcrumb]="page_name" [currentUrl]="currentUrl"></app-breadcrumb>
<!-- section start -->
<section class="wishlist-section section-b-space">
    <div class="container mobile-container">
        <div class="row">
            <div class="col-sm-3">
                <div class="account-sidebar" (click)="ToggleDashboard()">
                    <a hre="javascript:void(0)" class="popup-btn">
                        {{'my account' | translate}}
                    </a>
                </div>
                <div class="dashboard-left" [class.open]="openDashboard">
                    <div class="collection-mobile-back" (click)="ToggleDashboard()">
                        <span class="filter-back">
                            <i class="fa fa-angle-left" aria-hidden="true"></i> {{'Back' | translate}}
                        </span>
                    </div>
                    <div class="block-content">
                        <ul>
                            <ul>
                                <li><a data-lng="es" [routerLink]="'/pages/dashboard'">
                                        {{'address' | translate}}
                                    </a>
                                </li>
                                <li class="active"><a data-lng="es" [routerLink]="'/pages/my-orders'">
                                        {{'orders' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/my-coupones'">
                                        {{'coupones' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/browse-log'">
                                        {{'browse log' | translate}}
                                    </a>
                                </li>
                                <li><a data-lng="es" [routerLink]="'/pages/profile'">
                                        {{'my profile' | translate}}
                                    </a>
                                </li>
                                <li>
                                    <a data-lng="es" href="javascript:void(0)" (click)="userLogOut()">

                                        {{'logout' | translate}}
                                    </a>
                                </li>

                            </ul>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="overflow-auto col-md-9 col-sm-12">
                <table class="table cart-table table-responsive-xs">
                    <thead>
                        <tr class="table-head">

                            <th>رقم الطلب</th>
                            <th>{{'Number'|translate }} {{ 'products' | translate}}</th>
                            <th>{{'Order status' | translate}}</th>
                            <th>{{'Total-final' | translate}}</th>
                            <th>{{'Date Added' | translate}}</th>
                            <th>{{'ACTION' | translate}}</th>




                            <!-- <th scope="col">{{'Product Name' | translate}}</th> -->


                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let order of myOrders">

                            <td>
                                <p># {{order.count_invoice_type}}</p>
                            </td>
                            <td>
                                <p class="text-center">
                                    {{order.total_quantity}}
                                </p>
                            </td>
                            <td>
                                <p>{{order.status | translate}}</p>
                            </td>
                            <td>
                                <p>{{ (order.total_price) }} {{
                                    productService?.Currency.name }}</p>
                            </td>

                            <td class="text-center date-col">
                                {{order.date_added | date:'d-M-y h:mm a'}}
                            </td>
                            <td class="text-center td-btns">
                                <div class="flex-wrap justify-content-center align-items-center desktop-links">
                                    <a [routerLink]="'/pages/order/'+order.id"
                                        class="d-flex justify-content-around align-items-center"
                                        title="{{'Show' | translate}}">
                                        {{'Show' | translate}} <span class="mobile-btns"> {{'Order' | translate}}</span>
                                    </a>
                                    <a [routerLink]="'/pages/order-state/'+order.id"
                                        class="d-flex justify-content-around align-items-center"
                                        title="{{'follow' | translate}}">
                                        {{'follow' | translate}} <span class="mobile-btns"> {{'Order' | translate}}</span>
                                    </a>
                                    <a *ngIf="order.status == 'pending' && order.is_paid =='unPaid'"
                                        (click)="editOrder(order)" [href]="'javascript:void(0)'"
                                        class="d-flex justify-content-around align-items-center"
                                        title="{{'Edit' | translate}}">
                                        {{'Edit' | translate}} <span class="mobile-btns"> {{'Order' | translate}}</span>
                                    </a>
                                    <a href="javascript:void(0)"
                                        *ngIf="order.status != 'canceled' && order.is_paid =='unPaid'"
                                        class="d-flex justify-content-around align-items-center"
                                        title="{{'Cancel' | translate}}" (click)="openModal(order.id)">
                                        {{'Cancel' | translate}} <span class="mobile-btns"> {{'Order' |
                                            translate}}</span>
                                    </a>
                                </div>
                            </td>
                            <!-- <td> {{order.client_name}} </td> -->
                        </tr>
                        <tr *ngIf="no_data">
                            <td colspan="6" class="text-center">
                                {{'no data' | translate}}
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <div class="row wishlist-buttons">
            <br>
            <br>
        </div>
    </div>
</section>
<!--section end-->

<ng-template class="theme-modal" #newsletter let-modal>
    <div class="modal-content">
        <div class="modal-body modal7" style="background-image: unset;">
            <div class="p-0 container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="modal-bg">
                            <button type="button" class="close" aria-label="Close"
                                (click)="modal.dismiss('Cross click')">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="offer-content" *ngIf="step1">
                                <div class="circle-icon">
                                    <i class="ti-info-alt text-warning"></i>

                                </div>
                                <h2>{{'Cancel' | translate}} </h2>
                                <h4> {{'Do you want to cancel this order' | translate}} </h4>
                                <br>

                                <div class="modal-footer">
                                    <button type="button" class="mr-auto btn btn-primary"
                                        (click)="cancelInvoice()">{{'accept' | translate}}</button>
                                    <button type="button" class="btn btn-secondary" aria-label="Close"
                                        (click)="modal.dismiss('Cross click')">{{'Cancel' | translate}}</button>
                                </div>
                            </div>

                            <div class="offer-content" *ngIf="step2">

                                <h2>{{'Cancel' | translate}} </h2>

                                <div class="d-flex justify-content-center">
                                    <img src="assets/images/loader.gif" width="50px" height="50px">
                                </div>

                                <br>
                                <div class="modal-footer">
                                    <br>
                                    <br>
                                </div>
                            </div>

                            <div class="offer-content" *ngIf="step3">
                                <div class="circle-icon-check">
                                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                                </div>

                                <h2 class="text-success">{{'canceled Order Successfully' | translate}}</h2>


                                <br>
                                <div class="modal-footer">
                                    <br>
                                    <button type="button" class="mr-auto btn btn-primary" aria-label="Close"
                                        (click)="modal.dismiss('Cross click')">Ok</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!-- login -->
<section #login class="full-sidebar" *ngIf="loginclicked">
    <div class="shadow login-sidebar">
        <i class="ti-close login-icon" (click)="close()"></i>
        <app-fast-login (step5Reached)="onStep5Reached()"
            (stepSuccessReached)="onstepSuccessReached()"></app-fast-login>
    </div>
</section>